/**
 * Filter types Klevu support
 */
export var KlevuFilterType;
(function (KlevuFilterType) {
    KlevuFilterType["Options"] = "OPTIONS";
    KlevuFilterType["Slider"] = "SLIDER";
})(KlevuFilterType || (KlevuFilterType = {}));
